import * as TYPES from './type';
export default {
  // 教学班级
  [TYPES.CLASS_LIST](state, {
    result
  }) {
    state.classList = result.result
  },
  [TYPES.CLASS_INFO](state, {
    result,
    type
  }) {
    state.classInfo[type] = result.result
  },
  // 教学班级学生
  [TYPES.CLASS_STUDENT_LIST](state, {
    result
  }) {
    state.classStudentList = result.result
  },
  // 教学班级分组学生
  [TYPES.CLASS_GROUP_STU_LIST](state, {
    result
  }) {
    state.classGroupStuList = result.result
  },
  // 教学班级分组
  [TYPES.CLASS_GROUP_LIST](state, {
    result
  }) {
    state.classGroupList = result.result
  },
  // 教学班级获取教室
  [TYPES.CLASS_WACOM](state, {
    result, type
  }) {
    state.wacom[type] = result.result
  },
}
